import React, { createContext, useContext, useReducer } from 'react';
import { simpleTaskDeadLineNotifyReducer } from '../reducer/simpleTaskDeadLineNotifyReducer';

const SimpleTaskDeadLineNotifyContext = createContext({});

export const SimpleTaskDeadLineNotifyProvider = ({ children }) => {
  const [state, dispatch] = useReducer(simpleTaskDeadLineNotifyReducer, {});

  const setSimpleTaskDeadLineNotify = (config) => {
    return dispatch({ type: 'SET', payload: config });
  };

  const getSetSimpleTaskDeadLineNotify = () => {
    return dispatch({ type: 'GET' });
  };

  const value = {
    simpleTaskDeadLineNotify: state,
    setSimpleTaskDeadLineNotify,
    getSetSimpleTaskDeadLineNotify,
  };

  return <SimpleTaskDeadLineNotifyContext.Provider value={value}>{children}</SimpleTaskDeadLineNotifyContext.Provider>;
};

const useSimpleTaskDeadLineNotify = () => {
  return useContext(SimpleTaskDeadLineNotifyContext);
};

export default useSimpleTaskDeadLineNotify;
